import React from 'react'

const StrategicPurchasing = () => {
  return (
    <div className='mx-auto p-4'>
      StrategicPurchasing
    </div>
  )
}

export default StrategicPurchasing
